'use strict';

var requirePromise = require('./requirePromise');

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	requirePromise();
	return typeof Promise.prototype['finally'] === 'function' ? Promise.prototype['finally'] : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/promise.prototype.finally/polyfill.js
// module id = 283
// module chunks = 7